import type { RichContentEditorProps } from './../../ricos-common';
import { VERTICAL_EMBED_TYPE } from './../../ricos-content';

import type { VerticalType } from './consts';
import VerticalSearchModule from './VerticalSearchModule';

export function verticalEmbedEditorStrategy(
  instance: string | undefined,
  hasPlugin: (pluginType: string) => boolean
): RichContentEditorProps {
  if (!instance || !hasPlugin(VERTICAL_EMBED_TYPE)) {
    return {
      config: {},
    };
  }

  return {
    config: {
      [VERTICAL_EMBED_TYPE]: {
        verticalsApi: (type: VerticalType, locale = 'en') =>
          new VerticalSearchModule(type, instance, locale),
        getIsVisiblePromise: (type: VerticalType, locale = 'en') =>
          new VerticalSearchModule(type, instance, locale).isInstalled(),
      },
    },
  };
}
